export default {
  COMMON_PLAN: 'Plan Común',
}
